import router from '@/shared/router'
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import lojas from '@/domains/configuracoes/lojas/router/routes'
import usuarios from '@/domains/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/configuracoes/grupos_usuarios/router/routes'
import permissoes from '@/domains/configuracoes/permissoes/router/routes'
import planos from '@/domains/configuracoes/planos/router/routes'
import dominios from '@/domains/configuracoes/dominios/router/routes'
import ajuda from '@/domains/auxiliares/ajuda/router/routes'
import backupDados from '@/domains/configuracoes/backup_dados/router/routes'

let childrenRoutes = []
const paths = require.context('../', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => { childrenRoutes.push(val) })
    }
})

const routes = [
    {
        path: '/atendimentos',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            { 
                path: '', 
                component: () => import('../domains/inicio/views/Inicio') 
            },
            ...childrenRoutes
        ],
    },
    {
        path: '/atendimentos/sistema/acessar_erp',
        redirect: '/inicio'
    },
    {
        path: '/atendimentos/notificacoes',
        redirect: '/notificacoes'
    },
    {
        name: 'impressaoChamado',
        path: '/atendimentos/chamados/imprimir_pdf/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        }
    },
    ...formataRotasGlobais('atendimentos', dominios),
    ...formataRotasGlobais('atendimentos', lojas),
    ...formataRotasGlobais('atendimentos', usuarios),
    ...formataRotasGlobais('atendimentos', gruposUsuarios),
    ...formataRotasGlobais('atendimentos', permissoes),
    ...formataRotasGlobais('atendimentos', planos),
    ...formataRotasGlobais('atendimentos', ajuda),
    ...formataRotasGlobais('atendimentos', backupDados),
]

console.log('dev');

router.addRoutes(routes)

export default router 
